//信息隐藏
export function encryption(text, start = 0, end = 0, symbol = '...'){
    if(!text || (start == 0 && end == 0)) return text;
    return text.replace(new RegExp(`^.{${start}}([\\s\\S]*?).{${end}}$`,'ig'),function(p1, p2){
        if(p2){
            return text.replace(p2,symbol);
        }else{
            return text;
        }
    });
}
//高亮文本中的文字
export function highlight(text, need){
    const reg = new RegExp(need,'gi');
    return text.replace(reg,(matching)=>{
        return `<i style="font-style: normal;color: #7AD21A">${matching}</i>`;
    });
}